/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LifecycleStage } from './LifecycleStage';
import { LifecycleStageFromJSON, LifecycleStageFromJSONTyped, LifecycleStageToJSON } from './LifecycleStage';

/**
 *
 * @export
 * @interface PaginatedLifecycleStageList
 */
export interface PaginatedLifecycleStageList {
  /**
   *
   * @type {number}
   * @memberof PaginatedLifecycleStageList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedLifecycleStageList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedLifecycleStageList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<LifecycleStage>}
   * @memberof PaginatedLifecycleStageList
   */
  results: Array<LifecycleStage>;
}

/**
 * Check if a given object implements the PaginatedLifecycleStageList interface.
 */
export function instanceOfPaginatedLifecycleStageList(value: object): value is PaginatedLifecycleStageList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedLifecycleStageListFromJSON(json: any): PaginatedLifecycleStageList {
  return PaginatedLifecycleStageListFromJSONTyped(json, false);
}

export function PaginatedLifecycleStageListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedLifecycleStageList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(LifecycleStageFromJSON),
  };
}

export function PaginatedLifecycleStageListToJSON(value?: PaginatedLifecycleStageList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(LifecycleStageToJSON),
  };
}
